<template>
  <div class="dialogFace">
    <el-dialog
      :visible.sync="dialogVisible"
      width="840px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="titleDialog" slot="title">
        <p>学生须知</p>
        <i></i>
      </div>
      <div class="dataDialog">
        <div class="dataDialogDiv">
          <div v-html="studentNotice"></div>
        </div>
        <div class="radioDiv">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item prop="type">
              <el-checkbox-group v-model="ruleForm.type">
                <el-checkbox name="type">
                  <span class="radioText"
                    ><i>*</i>我已阅读并同意该须知上的一切内容</span
                  >
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <el-button class="btn" type="primary" @click="submitForm()"
          >下一步，人脸识别</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { testServe } from "@/api/home";

export default {
  name: "dialogFace",
  data() {
    return {
      //  学生须知开关 true为开启，false关闭
      dialogVisible: true,
      ruleForm: {
        type: [],
      },
      rules: {
        type: [
          {
            type: "array",
            required: true,
            message: "请勾选协议",
            trigger: "change",
          },
        ],
      },
      //  学生须知的内容
      studentNotice: "",
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$emit("isShowFace");
        }
      });
    },
  },
  created() {
    //  获取考试须知
    testServe.getStudentNotice().then((res) => {
      this.studentNotice = res.notification;
    });
  },
};
</script>

<style scoped lang="scss">
.titleDialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
}
.titleDialog p {
  font-size: 20px;
  color: #333;
}
.titleDialog i {
  width: 65px;
  height: 5px;
  @include bgColor("primary");
  margin-top: 10px;
}
.dataDialog {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.dataDialog .dataDialogDiv {
  width: 730px;
  height: 300px;
  border: 1px dashed #ebebeb;
  padding: 20px 22px 20px;
  overflow-y: scroll;
}
.dataDialog .dataDialogDiv::-webkit-scrollbar {
  @include uni-hidden;
}
.dataDialog .dataDialogDiv * {
  font-size: 15px;
  color: #666;
  line-height: 34px;
}
.radioDiv {
  width: 730px;
  margin-top: 30px;
}
.radioDiv .radioText {
  color: #333;
}
.radioDiv .radioText i {
  color: #c3191a;
  margin-right: 5px;
}
.btn {
  margin-top: 57px;
}
</style>
